import React from "react";
import styled, { css } from "styled-components";
import MapContext from "./MapContext";

const Loading = ({ isDisplayed }) => {
    return <MapContext.Consumer>
        { ({ mode }) => <Container isDisplayed={ isDisplayed }>
            <Loader mode={ mode }>
                <div></div>
                <div></div>
            </Loader>
        </Container> }
    </MapContext.Consumer> 
}

const Container = styled.div`
    width: 100%;
    padding: 24px;
    display: flex;
    justify-content: center;
    align-items: center;

    ${ props => !props.isDisplayed && css`
        display: none;
        height: 0;
        visibility: hidden;
    ` }
`

const Loader = styled.div`
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;

    div:nth-child(2) {
        animation-delay: -0.5s;
    }

    div {
        position: absolute;
        border: 4px solid #fff;
        ${ props => props.mode === "light" && css`
            border-color: black;
        ` }
        opacity: 1;
        border-radius: 50%;
        animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }

    @keyframes lds-ripple {
        0% {
            top: 36px;
            left: 36px;
            width: 0;
            height: 0;
            opacity: 1;
        }
        100% {
            top: 0px;
            left: 0px;
            width: 72px;
            height: 72px;
            opacity: 0;
        }
    }
`

export default Loading;